export const environment = {
  production: false,
  version:'Alterna Admin B.v.1.0.28',
  firebaseConfig: {
    apiKey: 'AIzaSyA2xOd9z7F0_5znn9SnZcEuGgnSlOojn7g',
    authDomain: 'alterna-7e286.firebaseapp.com',
    projectId: 'alterna-7e286',
    storageBucket: 'alterna-7e286.appspot.com',
    messagingSenderId: '588647199022',
    appId: '1:588647199022:web:a4f3bab742a6df00e54abf',
    vapidKey:
      'BJsmkNTDWY0ZsikgmMwNYNsbRoJmR4RTcAGLfIsWjC6BsO9kOJ-LZeQ3x2MPfQggle5nktHVzZb06UpgqlnbgRs',
  },
  apiRoot: 'https://api-dev.alternacultivacionapp.com/api/v1/',
};
